import GetQueryData from './module/GetQueryData';
import CookieManager from './module/CookieManager';
import AddClassOnLoad from './module/AddClassOnLoad';
import ToggleMenu from './module/ToggleMenu';
import ScrollWatch from './module/ScrollWatch';
import SmoothScroller from './module/SmoothScroller';
import ObservePosition from './module/ObservePosition';
import ChangeTab from './module/ChangeTab';
import ClickReadMore from './module/ClickReadMore';
import FileInputCustom from './module/FileInputCustom';

(() => {
	const addClassOnLoadInit = () => {
		const attributeName = 'data-loaded-addcls';
		new AddClassOnLoad({ attributeName });
	};

	const toggleMenu = () => {
		const dataAttrPref = 'data-toggle-menu';
		document.querySelectorAll(`[${dataAttrPref}-trigger]`).forEach(triggerElement => {
			const body = document.body;
			const html = document.documentElement;
			const menuOpenClass = triggerElement.getAttribute(`${dataAttrPref}-trigger`) || 'is-menuOpen';
			const rootClassElement = document.querySelector(`[${dataAttrPref}-root-class]`);
			const rootClass = rootClassElement ? rootClassElement.getAttribute(`${dataAttrPref}-root-class`) : null;
			new ToggleMenu({
				body,
				html,
				triggerElement,
				menuOpenClass,
				rootClass,
				customOption: {
					useRootClass: true // カスタムオプションはカスタマイズ可能
				}
			});
		});
	};

	const scrollWatchInit = () => {
		const dataAttrName = 'data-scroll-watch';
		document.querySelectorAll(`[${dataAttrName}]`).forEach(target => {
			const scrollThreshold = parseInt(target.getAttribute(`${dataAttrName}-threshold`), 10) || 100; // 閾値の取得
			const scrolledClass = target.getAttribute(dataAttrName) || 'is-scrolled'; // クラス名の取得

			new ScrollWatch({
				target,
				scrollThreshold,
				scrolledClass,
			});
		});
	};

	const smoothScrollerInit = () => {
		const smoothScrollLinks = '[href^="#"][data-smooth-scroll]';
		let isScrolling = false; // スクロール中かどうかを判定するフラグ
		const scrollSpeed = 1000; // スクロール速度

		document.addEventListener('click', event => {
			const target = event.target.closest(smoothScrollLinks);
			if (target) {
				event.preventDefault();
				if (isScrolling) return; // すでにスクロール中の場合は何もしない
				isScrolling = true; // スクロール開始時にフラグを立てる
				new SmoothScroller({
					speed: scrollSpeed,
					easing: 'easeInExpo'
				}, target);

				// スクロールが終わった後にフラグを解除
				setTimeout(() => {
					isScrolling = false;
				}, scrollSpeed); // スクロール速度と一致させる
			}
		}, { passive: false }); // タッチスクロールのパフォーマンス向上のため、passiveをfalseに設定
	};

	const observePositionInit = () => {
		const dataAttrPref = 'data-observe';
		const targets = document.querySelectorAll(`[${dataAttrPref}-target]`);
		targets.forEach(target => {
			const positionClasses = {
				bottomDown: target.getAttribute(`${dataAttrPref}-bottom-down`) || '',
				bottomOn: target.getAttribute(`${dataAttrPref}-bottom-on`) || '',
				bottomUp: target.getAttribute(`${dataAttrPref}-bottom-up`) || '',
				topDown: target.getAttribute(`${dataAttrPref}-top-down`) || '',
				topOn: target.getAttribute(`${dataAttrPref}-top-on`) || '',
				topUp: target.getAttribute(`${dataAttrPref}-top-up`) || ''
			};

			new ObservePosition(
				target,
				positionClasses,
				{ fireCustomEvent: true }
			);
		});
	};

	const changeTabInit = () => {
		const dataAttrPref = 'data-change-tab';
		document.querySelectorAll(`[${dataAttrPref}-wrap]`).forEach(wrap => {
			const buttons = Array.from(wrap.querySelectorAll(`[${dataAttrPref}-btn]`));
			const areas = Array.from(wrap.querySelectorAll(`[${dataAttrPref}-area]`));
			const activeClass = wrap.getAttribute(`${dataAttrPref}-wrap`);
			const def = parseInt(wrap.getAttribute(`${dataAttrPref}-def`), 10);
			const query = wrap.getAttribute(`${dataAttrPref}-query`);

			// ボタンとエリアがあればChangeTabインスタンスを生成
			if (buttons.length && areas.length) {
				new ChangeTab({
					wrap,
					buttons,
					areas,
					activeClass,
					def,
					query
				});
			}
		});
	};

	const gdprCheck = (() => {
		const body = document.body;
		const gdprDataPref = 'data-gdpr';
		const safeClassNamePattern = /^[a-zA-Z0-9-_]+$/; // クラス名のパターン
		const safeCookieNamePattern = /^[a-zA-Z0-9-_]+$/; // クッキー名のパターン

		let className = body.getAttribute(`${gdprDataPref}-class`); // クラス名を取得
		if (!className || !safeClassNamePattern.test(className)) { // クラス名がないか、パターンに一致しない場合
			className = 'gdpr';
		}

		let cookieName = body.getAttribute(`${gdprDataPref}-cookie`); // クッキー名を取得
		if (!cookieName || !safeCookieNamePattern.test(cookieName)) { // クッキー名がないか、パターンに一致しない場合
			cookieName = 'gdpr-acceptance';
		}
		if (!CookieManager.get(cookieName)) { // クッキーがない場合
			body.classList.add(className);
		} else {
			CookieManager.set(cookieName, 1, 365 * 2, '/'); // 2年間有効
		}

		document.addEventListener('click', function (event) { // クリックイベント
			if (event.target.matches(`[${gdprDataPref}-btn]`)) { // ボタンがクリックされた場合
				body.classList.remove(className);
				CookieManager.set(cookieName, 1, 365 * 2, '/'); // 2年間有効
			}
		});
	});

    const sharedTextData = (() => {
        const dataAttrPref = 'data-shared';
        const sharedWraps = document.querySelectorAll(`[${dataAttrPref}-wrap]`);

        const initializeLinkButton = (sharedWrap, linkButton) => {
            linkButton.addEventListener('click', (event) => {
                const queryValue = linkButton.getAttribute(`${dataAttrPref}-add-query`);
                const textElement = sharedWrap.querySelector(`[${dataAttrPref}-role="text-element"]`);
                if (textElement) {
                    const text = textElement.textContent.trim();
                    CookieManager.set('sharedText', text, 1);
                }
                if (queryValue) {
                    event.preventDefault();
                    const url = new URL(linkButton.href);
                    url.searchParams.append('cookieText', queryValue);
                    window.location.href = url.href;
                }
            });
        };

        const populateDisplayText = (sharedWrap, displayTextElement) => {
            const sharedText = CookieManager.get('sharedText');
            if (sharedText) {
                displayTextElement.textContent = sharedText;
                let hiddenInput = sharedWrap.querySelector(`[${dataAttrPref}-role="hidden-input"]`);
                if (!hiddenInput) {
                    hiddenInput = sharedWrap.querySelector('input[type="hidden"]');
                }
                if (hiddenInput) {
                    hiddenInput.value = sharedText;
                }
            }
        };

        const initializeSharedWrap = (sharedWrap) => {
            const linkButton = sharedWrap.querySelector(`[${dataAttrPref}-role="link-button"]`);
            const displayTextElement = sharedWrap.querySelector(`[${dataAttrPref}-role="display-text"]`);
            const hiddenInputElement = sharedWrap.querySelector(`[${dataAttrPref}-role="hidden-input"]`);

            if (linkButton) {
                initializeLinkButton(sharedWrap, linkButton);
            }

            const queryData = new GetQueryData().getData();
            const toggleAreas = sharedWrap.querySelectorAll(`[${dataAttrPref}-toggle-area]`);
            const hiddenInputs = sharedWrap.querySelectorAll(`input[type="hidden"], [${dataAttrPref}-role="hidden-input"]`);
            const displayTextElements = sharedWrap.querySelectorAll(`[${dataAttrPref}-role="display-text"]`);

            if (Object.keys(queryData).length > 0) {
                toggleAreas.forEach(el => el.parentNode.removeChild(el));
                hiddenInputs.forEach(el => el.value = CookieManager.get('sharedText'));
                displayTextElements.forEach(el => el.textContent = CookieManager.get('sharedText'));
            } else {
                hiddenInputs.forEach(el => {
                    if (!el.closest(`[${dataAttrPref}-toggle-area]`)) {
                        el.parentNode.removeChild(el);
                    }
                });
                displayTextElements.forEach(el => {
                    if (!el.closest(`[${dataAttrPref}-toggle-area]`)) {
                        el.parentNode.removeChild(el);
                    }
                });
                CookieManager.del('sharedText');
            }

            if (!sharedWrap.closest(`[${dataAttrPref}-toggle-area]`)) {  // トグルエリア内の場合は実行しない
                if (displayTextElement) {
                    populateDisplayText(sharedWrap, displayTextElement);
                }
                if (hiddenInputElement) {
                    hiddenInputElement.value = CookieManager.get('sharedText');
                }
            }
        };

        return () => {
            sharedWraps.forEach(initializeSharedWrap);
        };
    })();

	const readMoreInit = () => {
		const dataAttrPref = 'data-readmore'; // データ属性の接頭辞
		const wrapSelector = `[${dataAttrPref}-wrap]`; // ラッパー要素
		const btnSelector = `[${dataAttrPref}-btn]`; // ボタン
		const btnParentSelector = `[${dataAttrPref}-btn-parent]`; // ボタンの親要素
		const listSelector = `[${dataAttrPref}-list]`; // 表示する要素の親要素
		const addClassSelector = `${dataAttrPref}-add-class`; // 追加するクラス
		const btnParentAddClassSelector = `${dataAttrPref}-add-class`; // ボタンの親要素に追加するクラス
		const showNumberSelector = `${dataAttrPref}-show-number`; // 一度に表示する数
		const defaultClassToAdd = 'is-show'; // 追加するクラスのデフォルト値

		document.querySelectorAll(wrapSelector).forEach(wrap => {
			const btn = wrap.querySelector(btnSelector); // ボタン
			const btnParent = btn ? btn.closest(btnParentSelector) : null; // ボタンの親要素
			const list = wrap.querySelector(listSelector); // 表示する要素の親要素
			const numAttr = wrap.getAttribute(showNumberSelector); // 一度に表示する数
			const num = numAttr !== null ? parseInt(numAttr, 10) : null; // 一度に表示する数（10進数に変換）

			if (btn && list) { // ボタンと表示する要素がある場合
				new ClickReadMore({
					wrap,
					btn,
					btnParent,
					listSelector,
					num,
					addClassSelector,
					defaultClassToAdd,
					btnParentSelector,
					btnParentAddClassSelector,
					defaultNum: 5,
				});
			}
		});
	};

	const fileInputCustomInit = () => {
		const dataAttrPref = 'data-input-file';
		document.querySelectorAll(`[${dataAttrPref}-wrap]`).forEach(wrapper => {
			const inputElement = wrapper.querySelector('input[type="file"]');
			const fileNameElement = wrapper.querySelector(`[${dataAttrPref}-name]`);
			const resetButton = wrapper.querySelector(`[${dataAttrPref}-reset]`);

			if (inputElement && fileNameElement) {
				const hiddenInput = wrapper.querySelector(`input[type="hidden"][name="${inputElement.name}"]`); // wrapper内のinput type="hidden"要素を検索
				// hiddenInputが存在し、そのvalueが存在する場合、fileNameElementの値をそのvalueに設定
				if (hiddenInput && hiddenInput.value) {
					fileNameElement.textContent = hiddenInput.value;
				}
				const resetButtonSelector = `[${dataAttrPref}-reset]`;
				const classToAdd = resetButton.getAttribute('data-input-file-reset'); // data-input-file-reset属性からクラス名を取得
				new FileInputCustom({
					wrapper,
					inputElement,
					fileNameElement,
					resetButton,
					resetButtonSelector,
					classToAdd
				});
			}
		});
	};

	addClassOnLoadInit();
	toggleMenu();
	scrollWatchInit();
	smoothScrollerInit();
	observePositionInit();
	changeTabInit();
	readMoreInit();
	gdprCheck();
	sharedTextData();
	fileInputCustomInit();

})();

